import { platformStatsService } from "../../services/platformStas.service";
import { types } from "./types";

export const platformStatsAction = (data) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await platformStatsService(data);
  if (response?.status) {
    const result = response?.data?.data;
        dispatch({ type: types.PLATFORM_STATS, payload: result });

    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.PLATFORM_STATS,
      payload: {
          registeredUserCount: 0,
        avgAge: 0,
        totalExerciseVideos: 0,
        totalPrograms: 0
      },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};
